module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tNews\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal__section"
  }, [(_vm.notifications.length > 0) ? _c('div', _vm._l((_vm.notifications), function(item, i) {
    return _c('v-card', {
      key: i,
      staticClass: "notifications__item",
      attrs: {
        "outlined": ""
      }
    }, [(!item.seen) ? _c('v-card-title', {
      staticClass: "notifications__title"
    }, [_vm._v("\n\t\t\t\t\t\t        Unread news\n\t\t\t\t\t\t    ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
      staticClass: "notifications__text",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
      staticClass: "notifications__footer",
      attrs: {
        "no-gutters": "",
        "align": "center",
        "justify": "end"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.parseNotificationDate(item.created))
      }
    })])], 1)], 1)
  }), 1) : _c('div', {
    staticClass: "notifications__title"
  }, [_vm._v("\n                        No new news\n                    ")])]) : _c('div', {
    staticClass: "modal__section"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": "black",
      "indeterminate": ""
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f55b1d52","hasScoped":false}!./app/components/news-modal/template.html
// module id = 403
// module chunks = 0